import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

// items: [{ label, to }] — the last item is rendered as the current (non-link) page.
export default function Breadcrumbs({ items = [], className = "" }) {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={`flex flex-wrap items-center gap-1 text-sm ${className}`}>
      <Link to="/" className="inline-flex items-center text-current/70 hover:text-current opacity-80 hover:opacity-100"><Home className="w-4 h-4" /></Link>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className="inline-flex items-center gap-1">
            <ChevronRight className="w-4 h-4 opacity-50" />
            {last || !it.to ? (
              <span className="font-600" data-testid={`crumb-current`}>{it.label}</span>
            ) : (
              <Link to={it.to} className="opacity-80 hover:opacity-100 hover:underline underline-offset-2" data-testid={`crumb-${i}`}>{it.label}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
